import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FraudEvidenceRow } from '../../fraud-case-details.models';

@Component({
  selector: 'app-fraud-case-evidence',
  templateUrl: './fraud-case-evidence.component.html',
  styleUrls: ['../fraud-case-card.css', './fraud-case-evidence.component.css']
})
export class FraudCaseEvidenceComponent {
  @Input() items: FraudEvidenceRow[] = [];
  @Input() loading = false;
  @Input() error = '';
  @Output() retry = new EventEmitter<void>();
}
